const basicSettings = (r) =>
  require.ensure(
    [],
    () => r(require('../views/setting/BasicSettings.vue')),
    'basicSettings'
  )



    //设置
export default[
  {
    name: 'basicSettings',
    path: '/basicSettings',
    component: basicSettings,
    meta: { title: '基础信息' },
  }
]